import { c as _c } from "react/compiler-runtime";
import { DeleteAccountView } from "@repo/ui/components/profile/DeleteAccountView";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { authClient } from "@/clients/authClient";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto/radera-konto")({
  component: DeleteAccountPage
});
function DeleteAccountPage() {
  const $ = _c(2);
  const navigate = useNavigate();
  const handleSuccess = _temp;
  let t0;
  if ($[0] !== navigate) {
    t0 = /*#__PURE__*/_jsx(DeleteAccountView, {
      authClient: authClient,
      onSuccess: handleSuccess,
      onBack: () => navigate({
        to: "/mitt-konto"
      })
    });
    $[0] = navigate;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp() {
  authClient.signOut();
  window.location.reload();
}